/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutoDecisioningSummaryCustomizedFacilitiesInner } from './AutoDecisioningSummaryCustomizedFacilitiesInner';
import {
    AutoDecisioningSummaryCustomizedFacilitiesInnerFromJSON,
    AutoDecisioningSummaryCustomizedFacilitiesInnerFromJSONTyped,
    AutoDecisioningSummaryCustomizedFacilitiesInnerToJSON,
    AutoDecisioningSummaryCustomizedFacilitiesInnerToJSONTyped,
} from './AutoDecisioningSummaryCustomizedFacilitiesInner';

/**
 * 
 * @export
 * @interface AutoDecisioningSummary
 */
export interface AutoDecisioningSummary {
    /**
     * 
     */
    customized_facilities: Array<AutoDecisioningSummaryCustomizedFacilitiesInner>;
}

/**
 * Check if a given object implements the AutoDecisioningSummary interface.
 */
export function instanceOfAutoDecisioningSummary(value: object): value is AutoDecisioningSummary {
    if (!('customized_facilities' in value) || value['customized_facilities'] === undefined) return false;
    return true;
}

export function AutoDecisioningSummaryFromJSON(json: any): AutoDecisioningSummary {
    return AutoDecisioningSummaryFromJSONTyped(json, false);
}

export function AutoDecisioningSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoDecisioningSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'customized_facilities': ((json['customized_facilities'] as Array<any>).map(AutoDecisioningSummaryCustomizedFacilitiesInnerFromJSON)),
    };
}

export function AutoDecisioningSummaryToJSON(json: any): AutoDecisioningSummary {
    return AutoDecisioningSummaryToJSONTyped(json, false);
}

export function AutoDecisioningSummaryToJSONTyped(value?: AutoDecisioningSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customized_facilities': ((value['customized_facilities'] as Array<any>).map(AutoDecisioningSummaryCustomizedFacilitiesInnerToJSON)),
    };
}

